import { render } from "./lessonFileDetail.vue?vue&type=template&id=04aa21ee&scoped=true"
import script from "./lessonFileDetail.vue?vue&type=script&lang=js"
export * from "./lessonFileDetail.vue?vue&type=script&lang=js"

import "./lessonFileDetail.vue?vue&type=style&index=0&id=04aa21ee&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aa21ee"]])

export default __exports__